import React from "react";
import { Box, Card, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import AuthLayout from "./authLayout";

const PasswordMailSend: React.FC = () => {
  const navigate = useNavigate();

  const reSendMail = (event: React.FormEvent) => {
    event.preventDefault();
    navigate(PATHS.AUTH_PASSWORD_RESET);
  };

  return (
    <AuthLayout >
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 5,
          display: "flex",
          flexDirection: "column",
          maxWidth: "470px",
          width: "100%",
        }}
      >
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Typography variant="h5" align="center" sx={{ mb: 2 }}>
            メールを送信しました
          </Typography>
          <Typography variant="body2" align="center">
            以下のメールアドレスに確認メールを送信しましたので、添付されてるURLをクリックしてパスワードの再設定を完了してください
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            sample@myskillsheet.com
          </Typography>
          <Typography variant="body2" align="center">
            ※メールが届かない場合は下のボタンをクリックして確認メールの再送信をするか管理者に確認をしてください
          </Typography>
          <Button
            sx={{
              mt: 2,
              height: "42px",
              border: "1px solid",
              color: "primary.main",
              bgcolor: "white",
              "&:hover": {
                bgcolor: "white", // ホバー時も背景色は白に
                opacity: 0.9,
              },
            }}
            onClick={reSendMail}
            variant="outlined"
            fullWidth
          >
            再送信
          </Button>
        </Box>
      </Card>
    </AuthLayout>
  );
};

export default PasswordMailSend;
